import { filter, includes } from 'lodash'
import PropTypes from 'prop-types'
import React from 'react'

import PropertyFilters from '../../../../components/filters/components/PropertyFilters'

export default function StockDiscrepanciesResidentFilter(props) {
  const {
    activeFilters,
    setActiveFilters,
    preferredPeopleNominative,
    residents
  } = props

  const allFilters = {
    resident: {
      label: preferredPeopleNominative,
      filters:
        residents &&
        residents.map((resident, i) => ({
          value: resident.id,
          label: `${resident.name.first} ${resident.name.last}`
        }))
    }
  }

  return (
    <div style={styles.residentFilter}>
      <PropertyFilters
        activeFilters={activeFilters}
        allFilters={allFilters}
        expandedView
        onChange={({ key, value }) => {
          const exists = includes(activeFilters[key], value)
          if (!value.length) {
            // This handles clearing all filters
            setActiveFilters({ resident: [] })
          } else {
            setActiveFilters({
              ...activeFilters,
              [key]: exists
                ? filter(activeFilters[key], (i) => i !== value)
                : [...(activeFilters[key] || []), value]
            })
          }
        }}
      />
    </div>
  )
}

StockDiscrepanciesResidentFilter.propTypes = {
  activeFilters: PropTypes.object.isRequired,
  preferredPeopleNominative: PropTypes.string.isRequired,
  residents: PropTypes.array.isRequired,
  setActiveFilters: PropTypes.func.isRequired
}

const styles = {
  residentFilter: {
    marginLeft: 16
  }
}
